import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/api';
import './Login.css';

function ClockIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <circle cx="14" cy="14" r="12" stroke="#38bdf8" strokeWidth="1.75"/>
      <line x1="14" y1="14" x2="14" y2="8" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
      <line x1="14" y1="14" x2="19" y2="17" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="14" cy="14" r="1.5" fill="#38bdf8"/>
    </svg>
  );
}

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await authService.login(username, password);
      login(response.data.token, response.data.username, response.data.roles || []);
      navigate('/home');
    } catch (err) {
      setError(err.response?.data?.message || 'Anmeldung fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-card">
        <div className="login-brand">
          <ClockIcon />
          <span className="brand-text">Kimai<strong>Assist</strong></span>
        </div>

        <h1 className="login-title">Willkommen zurück</h1>
        <p className="login-subtitle">Melde dich an, um fortzufahren</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Benutzername</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Passwort</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
